/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheRemplacementDto } from './FcbRechercheRemplacementDto';
import {
    FcbRechercheRemplacementDtoFromJSON,
    FcbRechercheRemplacementDtoFromJSONTyped,
    FcbRechercheRemplacementDtoToJSON,
} from './FcbRechercheRemplacementDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheRemplacementDtoPaginatedResults
 */
export interface FcbRechercheRemplacementDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheRemplacementDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheRemplacementDto>}
     * @memberof FcbRechercheRemplacementDtoPaginatedResults
     */
    results?: Array<FcbRechercheRemplacementDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheRemplacementDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheRemplacementDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheRemplacementDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheRemplacementDtoPaginatedResultsFromJSON(json: any): FcbRechercheRemplacementDtoPaginatedResults {
    return FcbRechercheRemplacementDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheRemplacementDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheRemplacementDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheRemplacementDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheRemplacementDtoPaginatedResultsToJSON(value?: FcbRechercheRemplacementDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheRemplacementDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

